import React, { Component } from 'react';

export class SlideshowScreens extends Component {
    render() {
        // TODO: Convert each instance to a component and wrap with a for loop
        return (
            <div id="slideshow-screens">
                <div id="photogrid" className="pagesection">
                    <div id="screens">
                        <div className="screen-preview">
                            <div className="inner">
                                <img src="./images/slides/slide-1-preview.jpg" alt="" />
                            </div>
                        </div>

                        <div className="screen-preview">
                            <div className="inner">
                                <img src="./images/slides/slide-2-preview.jpg" alt="" />
                            </div>
                        </div>

                        <div className="screen-preview">
                            <div className="inner">
                                <img src="./images/slides/slide-3-preview.jpg" alt="" />
                            </div>
                        </div>

                        <div className="screen-preview">
                            <div className="inner">
                                <img src="./images/slides/slide-4-preview.jpg" alt="" />
                            </div>
                        </div>

                        <div className="screen-preview">
                            <div className="inner">
                                <img src="./images/slides/slide-5-preview.jpg" alt="" />
                            </div>
                        </div>

                        <div className="screen-preview">
                            <div className="inner">
                                <img src="./images/slides/slide-6-preview.jpg" alt="" />
                            </div>
                        </div>

                        <div className="screen-preview">
                            <div className="inner">
                                <img src="./images/slides/slide-7-preview.jpg" alt="" />
                            </div>
                        </div>

                        <div className="screen-preview">
                            <div className="inner">
                                <img src="./images/slides/slide-8-preview.jpg" alt="" />
                            </div>
                        </div>

                        <div className="screen-preview">
                            <div className="inner">
                                <img src="./images/slides/slide-9-preview.jpg" alt="" />
                            </div>
                        </div>

                        <div className="screen-preview">
                            <div className="inner">
                                <img src="./images/slides/slide-10-preview.jpg" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/sections/AppSlideshow/SlideshowScreens.jsx